
import AppContactSearch from "@/components/contacts/ContactSearchWithBrowseAndCreate.vue";
import AppSellCategorySelect from "@/components/SellCategorySelect.vue";
import Vue from "vue";
import {SaleType} from "@/models/base";
import {SaleEditState} from "../../utils/sale-edit/sale-edit-state";
import AppSaleTypeSelect from "./SaleTypeSelect.vue";
import AppBreadcrumb from "./SaleEditBreadcrumb.vue";
import AppSaleEditVatRegimeSelect from "./SaleEditVatRegimeSelect.vue";

export default Vue.extend({
	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	computed: {
		ignoredTypes(): number[] {
			return this.state.getIgnoredSaleTypes();
		}
	},
	methods: {
		onTypeChange(newType: SaleType) {
			this.state.setSaleType(newType);
		},
	},
	components: {
		AppContactSearch,
		AppSellCategorySelect,
		AppSaleTypeSelect,
		AppBreadcrumb,
		AppSaleEditVatRegimeSelect
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
